import { Box, DateField, Message } from '@flos/react-ui';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import StringParagraph from './StringParagraph';
import { useHippoText } from '../../../hooks/useHippoText';
import {
    addMonths,
    convertDateToLocalDateDTO,
    convertLocalDateDTOToDate
} from '../../../utils/dateUtil';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { startDateAtom } from '../../../recoil/atoms/startDateAtom';
import { jobAtom } from '../../../recoil/atoms/jobAtom';
import { useState } from 'react';

const EffectiveDateExternalCaseNotSupported = ({
    coverables,
    selectedDate,
    setSelectedDate,
    isEffDateExtCaseNotSupportedIsValid
}: {
    coverables: CoverableDTO;
    selectedDate?: Date;
    setSelectedDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
    isEffDateExtCaseNotSupportedIsValid: undefined | boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const setStartDateDTO = useSetRecoilState(startDateAtom);
    const { digitalAcceptDate } = useRecoilValue(jobAtom);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const onStartDateChange = (date: Date): void => {
        setSelectedDate(date);
        const startDate = convertDateToLocalDateDTO(date);

        const updateDate = {
            fixedId: coverables?.fixedId ?? '',
            lobPrefix: coverables?.lobCode ?? '',
            effectiveDate: startDate
        };
        setStartDateDTO([updateDate]);
        setHasUnsavedChanges(true);
    };

    return (
        <Box padding="large" className="u-spacing-stack-l">
            {coverables?.flavourName && <h4>{coverables?.flavourName}</h4>}
            {coverables?.name && <p>{coverables?.name}</p>}
            <StringParagraph space={true}>
                {getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-NO-CANCELLATION-SUBHEADER')}
            </StringParagraph>
            <DateField
                selected={selectedDate}
                label="Vælg dato"
                onChange={onStartDateChange}
                minDate={new Date()}
                maxDate={
                    digitalAcceptDate !== undefined
                        ? addMonths(convertLocalDateDTOToDate(digitalAcceptDate), 13)
                        : undefined
                }
                dateFormat="dd. MMMM yyyy"
                isValid={
                    isEffDateExtCaseNotSupportedIsValid === undefined ||
                    isEffDateExtCaseNotSupportedIsValid ||
                    hasUnsavedChanges
                }
            />
            {coverables.lobCode === 'CHO' && (
                <Message theme="warning" className="u-spacing-stack-bottom-7">
                    {getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-ACCEPTANCE-DATE-WARNING')}
                </Message>
            )}
        </Box>
    );
};

export default EffectiveDateExternalCaseNotSupported;
